import React, { useContext } from 'react'

import { useSelector } from 'react-redux'
import { useRouteMatch } from 'react-router-dom'

import AnalyticsPostCampaignReportListViewProfile from '@components/Analytics/PostCampaignReport/ListView/Profile/Profile'
import { CampaignContext } from '@context/Campaign'
import { PCRChannels } from '@enums'
import { IApplicationState } from '@store'
import { selectPostMetricIds } from '@store/postCampaignReport'
import { selectCampaignId } from '@store/router'
import Theme from '@theme'
import { Container } from '@tribegroup'
import AnalyticsPostCampaignReportListViewHeaders from '../../ListView/Headers/Headers'
import AnalyticsPostCampaignReportListView from '../../ListView/ListView'
import AnalyticsPostCampaignReportPostListItem from './Item/Item'

export const getBackgroundColor = (index) =>
  index % 2 === 0 ? Theme.whiteColor : Theme.grey100Color

const AnalyticsPostCampaignReportPostList: React.FC = () => {
  const match = useRouteMatch()
  const campaignId = selectCampaignId(match) as number
  const submissionIds = useSelector((state: IApplicationState) =>
    selectPostMetricIds(state, campaignId, PCRChannels.IGPosts),
  )

  const {
    campaign: { is_price_hidden: isPriceHidden },
  } = useContext(CampaignContext)

  const translationKeys = [
    'published',
    !isPriceHidden && 'spend',
    'followers',
    'likes',
    'comments',
    'eng',
    'engagementPct',
    !isPriceHidden && 'cpe',
  ].filter(Boolean) as ReadonlyArray<string>

  const profiles = submissionIds.map((submissionId, index) => (
    <Container data-testid="post-profile-wrapper" key={`profile-${submissionId}`}>
      <AnalyticsPostCampaignReportListViewProfile
        backgroundColor={getBackgroundColor(index)}
        submissionId={submissionId}
      />
    </Container>
  ))

  return (
    <AnalyticsPostCampaignReportListView
      profiles={profiles}
      headers={
        <AnalyticsPostCampaignReportListViewHeaders
          translationKeys={translationKeys}
          isPriceHidden={isPriceHidden}
        />
      }
    >
      {submissionIds.map((submissionId, index) => (
        <Container key={`post-list-${submissionId}`} data-testid="post-list-item">
          <AnalyticsPostCampaignReportPostListItem
            submissionId={submissionId}
            backgroundColor={getBackgroundColor(index)}
          />
        </Container>
      ))}
    </AnalyticsPostCampaignReportListView>
  )
}

export default AnalyticsPostCampaignReportPostList
